import React, { useEffect, useState } from 'react';
import api from '../../services/api';

/**
 * Find a Video Library video by its topic tags, to connect it to a lesson (Jenn, 2026-10-29: tag
 * bubbles on our videos "so they show up in searches and are easy to locate to connect to our
 * courses"). Pick a topic, tap a video, and its ID goes into the lesson's video box.
 */
export default function VideoTopicPicker({ onPick, currentId }) {
  const [tags, setTags] = useState(null);
  const [tag, setTag] = useState('');
  const [videos, setVideos] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/admin/tags', { params: { kind: 'video' } }).then(r => setTags(r.data.tags)).catch(() => setTags([]));
  }, []);
  useEffect(() => {
    if (!tag) { setVideos(null); return; }
    setError(null);
    api.get('/admin/tags/videos', { params: { tag } }).then(r => setVideos(r.data.videos))
      .catch(err => setError(err.response?.data?.error || 'Could not load those videos.'));
  }, [tag]);

  if (!tags) return null;
  if (tags.length === 0) {
    return <p className="text-[11px] text-gray-400 mt-1.5">Tip: give videos topic tags in the Video Library, and you can find them by topic here.</p>;
  }
  return (
    <div className="mt-2">
      <select value={tag} onChange={e => setTag(e.target.value)}
        className="w-full border border-gray-200 rounded-lg px-3 py-2 text-xs text-reset-brown focus:outline-none focus:ring-2 focus:ring-reset-terracotta">
        <option value="">Find a video by topic…</option>
        {tags.map(t => <option key={t.tag} value={t.tag}>{t.tag} ({t.n})</option>)}
      </select>
      {error && <p className="text-xs text-gray-600 mt-1">{error}</p>}
      {videos && (
        <ul className="mt-2 max-h-56 overflow-y-auto space-y-1">
          {videos.map(v => (
            <li key={v.id}>
              <button type="button" onClick={() => onPick(v.id)}
                className={`w-full flex items-center gap-2 rounded-lg border px-2 py-1.5 text-left hover:border-reset-terracotta ${currentId === v.id ? 'border-reset-terracotta bg-reset-terracotta/5' : 'border-gray-100'}`}>
                {v.thumbnailUrl && <img src={v.thumbnailUrl} alt="" className="w-16 aspect-video object-contain bg-reset-terracotta/10 rounded" />}
                <span className="text-xs text-reset-brown flex-1 min-w-0 truncate">{v.title || v.id}</span>
                {currentId === v.id && <span className="text-[10px] text-reset-terracotta shrink-0">On this lesson</span>}
              </button>
            </li>
          ))}
          {videos.length === 0 && <li className="text-xs text-gray-400">No videos with that topic yet.</li>}
        </ul>
      )}
    </div>
  );
}
